export default "__VITE_ASSET__CMkuy3mP__"